export const ONBOARDING_FLOW = {
    intro: {
        messages: [
            'Hey {{firstName}}! In the next few minutes we\'ll build the system that finds prospects, creates outreach and generates pipeline for your business.',
        ],
        options: [
            { id: 'yes', label: "Start with my campaign", next: 'website-for-ai-messaging' },
            { id: 'no', label: 'Show me how Houdiny works', next: 'do-not-get-it' },
            { id: 'help', label: 'I’m new to outbound', next: 'how-help' },
        ],
    },
    'no-experience': {
        messages: [
            "Houdiny AI is your AI-powered outbound system — it finds your ideal customers, writes personalized outreach, and runs your LinkedIn and email campaigns on autopilot, so you book more meetings with far less manual work.",
        ],
        options: [
            { id: 'no-experience-continue', label: "Thanks, let's continue", next: 'website-for-ai-messaging' },
            { id: 'do-not-get-it', label: "I still don't get it", next: 'do-not-get-it' },
        ],
    },
    'how-help': {
        messages: [
            'Perfect.\n' ,
            'You don\'t need outbound experience.\n' ,
            'I\'ll help you build your first client acquisition system step by step.',
        ],
        options: [
            { id: 'how-help-continue', label: "Build My Outbound Machine", next: 'website-for-ai-messaging' },
            { id: 'do-not-get-it', label: "Show me how Houdiny works", next: 'do-not-get-it' },
        ],
    },
    'do-not-get-it': {
        messages: [
            'Most companies still generate clients the old way.' ,
            'Manual prospecting. Disconnected tools. Inconsistent pipeline.' ,
            'Watch this 5-minute breakdown to see how modern companies build outbound systems instead.',
        ],
        video: {
            src: 'https://houdiny-bucket-staging.s3.eu-central-1.amazonaws.com/houdiny/onboarding/houdiny-tutorial.mp4',
        },
        options: [
            { id: 'do-not-get-it-continue', label: "Build My Outbound Machine", next: 'website-for-ai-messaging' },
        ],
    },
    'email-campaign': {
        messages: ["The key to success is with targeting the right companies." ,
        "Who should your system focus on?"],
        options: [
            { id: 'ai-generate-icp', label: 'Find my best-fit customers', next: 'generating-icp', generateIcpFromOffer: true },
            // { id: 'i-know-my-icp', label: 'I know my ICP, I want AI to find it', next: 'i-know-my-icp' },
            // { id: 'i-do-not-know-my-icp', label: "Help me figure it out", next: 'i-do-not-know-my-icp' },
        ],
    },
    'generating-icp': {
        processing: {
            title: 'Designing your ideal customer profile.',
            steps: [
                'Reading your offer',
                'Identifying who buys it',
                'Picking decision-maker titles',
                'Matching the target industry',
            ],
            next: 'icp-recommendation',
        },
    },
    'icp-recommendation': {
        messages: ["Based on your offer, these are the companies and decision-makers most likely to become customers."
        ,
        "Review or adjust before I start building your lead list."],
        icpRecommendation: true,
        next: 'processing-icp',
    },
    'i-know-my-icp': {
        messages: ["Not seeing exactly who you're looking for?"
        ,
        "Tell me what you'd like to change and I'll refine the list."],
        input: {
            placeholder: 'Type here...',
            next: 'processing-icp',
            prefillIcp: true,
        },
        options: [],
    },
    'i-do-not-know-my-icp': {
        messages: ["Share your website and I'll extract details about your target audience."],
        input: {
            variant: 'url',
            placeholder: 'www.websiteurl.com',
            buttonLabel: 'Fetch',
        },
        options: [
            { id: 'i-do-not-have-website', label: "I don't have a website", next: 'i-know-my-icp' },
        ],
    },
    'processing-icp': {
        processing: {
            title: 'Analyzing your audience.',
            steps: [
                'Understanding your ICP',
                'Identifying relevant industries',
                'Matching decision-makers',
                'Verifying company data',
                'Enriching lead profiles',
                'Building your lead list',
            ],
            next: 'prospects-result',
        },
    },
    'prospects-result': {
        prospects: {
            message: 'Searching for prospects that match your ICP...',
            totalRows: 10,
        },
    },
    'linkedin-flow-ready': {
        linkedinFlowReady: {
            title: 'LinkedIn Flow for Campaign is Ready',
        },
        // messages:["Your LinkedIn outreach sequence is ready.\n" ,
        // "I've created the first version based on your offer, target market and positioning."],
        options: [
            { id: 'lets-continue', label: "Let's Continue", next: 'campaign-messaging' },
            // { id: 'custom-sequence', label: 'Custom Sequence', customSequence: true },
        ],
    },
    'building-custom-sequence': {
        processing: {
            title: 'Setting up your custom sequence.',
            steps: ['Saving your prospects', 'Creating your campaign', 'Opening the sequence builder'],
        },
    },
    'campaign-messaging': {
        messages: ["Your audience and campaign are ready.\n",
        "The final step is creating the outreach messages.\n",
        "How would you like to proceed?"],
        options: [
            { id: 'ai-message-template', label: 'Generate My Messages (recommended)', next: 'creating-unique-messaging', generateMessagesFromOffer: true },
            { id: 'write-messages-myself', label: 'I\'ll Write My Own', next: 'connect-linkedin' },
        ],
    },
    'connect-linkedin': {
        connectLinkedin: true,
    },
    'campaign-ready': {
        campaignReady: true,
    },
    'website-for-ai-messaging': {
        messages: [
            "Every great outbound system starts with understanding the offer.",
          "Let's build yours."
        ],
        offerForm: true,
        next: 'email-campaign',
    },
    'creating-unique-messaging': {
        processing: {
            title: 'Creating Unique Messaging.',
            steps: [
                'Messaging',
                'Pain Points',
                'Finding Right Tone',
                'Conversion Optimization',
                'Finalizing',
            ],
            next: 'campaign-messages',
        },
    },
    'campaign-messages': {
        messages: ["Your outreach sequence is ready.\n"
        ,
        "I've created the first version based on your offer, audience and campaign strategy.\n"
        ,
        "Review the messages below and make any changes you'd like before launch."],
        messagingMessages: true,
        options: [
            { id: 'confirm-messages', label: 'Connect LinkedIn & Launch', next: 'connect-linkedin' },
        ],
    },
}

export const PROSPECTS_NEXT_OPTIONS = [
    { id: 'build-linkedin-flow', label: 'Build My Campaign', next: 'linkedin-flow-ready' },
    { id: 'refine-list', label: 'Refine the list', next: 'i-know-my-icp' },
]

export const LINKEDIN_TEMPLATE = {
    name: 'LinkedIn Conversion Machine',
    steps: [
        { type: 'send_connection' },
        { type: 'wait_for_connection' },
        { type: 'send_message' },
        { type: 'delay', delayValue: 2, delayUnit: 'days' },
        { type: 'send_message' },
        { type: 'delay', delayValue: 3, delayUnit: 'days' },
        { type: 'send_message' },
    ],
}

export const TEMPLATE_MESSAGES = [
    {
        id: 'message-1',
        label: 'Message 1',
        value: `Hi {{first_name}},\n\nhappy we connected!\n\nHope you're having a great day so far.\n\nI'm part of the team behind Houdiny AI and I'm genuinely excited about what we're building!\n\nI'd love to share a bit more with you, if you're open to it.`,
    },
    {
        id: 'message-2',
        label: 'Message 2',
        value: 'Did you get a chance to see my previous message?',
    },
    {
        id: 'message-3',
        label: 'Message 3',
        value: `Hi {{first_name}}, I'll keep this short — I know inboxes get busy. If making your outbound run on autopilot is something you're exploring, I'd love to show you exactly how Houdiny AI could help. Open to a quick look?`,
    },
]
